import { useRef } from "react";
import { Reveal } from "./Reveal";
import { cn } from "@/lib/utils";
import { WEBINAR_CARDS } from "@/data/content";
import { CTAButton } from "./CTAButton";

const SPANS = [
  "lg:col-span-4",
  "lg:col-span-2",
  "lg:col-span-3",
  "lg:col-span-3",
  "lg:col-span-2",
  "lg:col-span-4",
];

const SpotlightCard = ({ card, index, className }) => {
  const ref = useRef(null);
  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${e.clientX - r.left}px`);
    el.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      data-testid={`webinar-card-${index}`}
      className={cn(
        "group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-brand-surface p-7 transition-all duration-300 hover:-translate-y-1 hover:border-white/20 sm:p-8",
        className,
      )}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{
          background:
            "radial-gradient(320px circle at var(--mx) var(--my), rgba(46,240,138,0.12), transparent 70%)",
        }}
      />
      <div className="relative flex h-14 w-14 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-brand-green transition-colors duration-300 group-hover:border-brand-green/40">
        <card.icon className="h-7 w-7" />
      </div>
      <span className="relative mt-6 font-heading text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-blue">
        {card.tag}
      </span>
      <h3 className="relative mt-2 font-heading text-xl font-bold leading-snug text-white sm:text-2xl">
        {card.title}
      </h3>
      <p className="relative mt-3 font-body text-sm leading-relaxed text-white/60">{card.text}</p>
    </div>
  );
};

export const WebinarContent = () => {
  return (
    <section id="inhalte" data-testid="webinar-content" className="relative py-24 sm:py-32">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(90%_60%_at_100%_0%,rgba(230,0,255,0.08),transparent_55%)]" />
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <span className="font-heading text-xs font-semibold uppercase tracking-[0.24em] text-brand-blue">
              Was erfahre ich im Webinar?
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-[3.4rem]">
              Im Webinar zeige ich dir den{" "}
              <span className="text-gradient-brand">kompletten Einstieg.</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-6">
          {WEBINAR_CARDS.map((card, i) => (
            <Reveal key={card.title} delay={(i % 3) * 0.08} className={cn("h-full", SPANS[i])}>
              <SpotlightCard card={card} index={i} className="h-full" />
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14 flex justify-center">
            <CTAButton testId="webinar-content-cta" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
